export default __webpack_public_path__ + "static/media/bg3.004b856e.png";